import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { useStyles } from './useStyles';

interface IInfoProps {
  className?: string;
  children: ReactElement | string;
}

export function Info({ children, className }: IInfoProps): ReactElement {
  const { cx, classes } = useStyles();

  return (
    <Typography
      className={cx(classes.root, className)}
      component="div"
      variant="body2"
    >
      {children}
    </Typography>
  );
}
